import { DeleteOutlined, SettingOutlined } from '@ant-design/icons';
import { Button, message, Space } from 'antd';
import React from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { tagApiService } from 'service/api/tagApiService';
import { TableColumnInterface } from 'type/tableType';
import { TagInterface } from 'type/tagType';
import * as Component from '../../../../shared/components';
import { CustomButtonComponent } from '../../../../shared/components';

export default function Category(): React.JSX.Element {
  const navigate = useNavigate();

  const columns: TableColumnInterface<TagInterface>[] = [
    {
      title: 'NAME',
      dataIndex: 'name',
      key: 'name',
      sorter: (a: TagInterface, b: TagInterface) => a.name.localeCompare(b.name),
      render: (text: string, record: TagInterface) => (
        <a
          href="#"
          className="people-title"
          onClick={() => navigate(`/tag/edit/${record.id || 0}`)}
        >
          {text.toLowerCase()}
        </a>
      ),
    },
    {
      title: 'Slug',
      dataIndex: 'slug',
      key: 'slug',
    },
    {
      title: 'ACTIONS',
      key: 'actions',
      dataIndex: 'actions',
      render: (_text: string, record: TagInterface) => (
        <Space>
          <Button
            icon={<SettingOutlined />}
            onClick={() => navigate(`/tag/edit/${record.id || 0}`)}
            className="action-btn"
          />
          <Button
            icon={<DeleteOutlined />}
            onClick={() => message.info('You do not have permission')}
            className="action-btn delete-btn"
          />
        </Space>
      ),
    },
  ];

  const [searchParams, setSearchParams] = useSearchParams();

  const fetchTagList = async (
    params: URLSearchParams
  ): Promise<{ data: TagInterface[]; count: number }> => {
    const { results, count } = await tagApiService.fetchTagList(params);
    return { data: results, count };
  };

  const AddButton = (): JSX.Element => {
    return (
      <CustomButtonComponent
        text={`+ Add Tag`}
        onClick={() => navigate('/tag/add')}
        size={'small'}
      />
    );
  };

  return (
    <Component.BasePageComponent>
      <Component.TableComponent<TagInterface>
        name="Tag"
        dataFetch={fetchTagList}
        columns={columns}
        additionalButton={[AddButton()]}
        searchParams={searchParams}
        setSearchParams={setSearchParams}
      />
    </Component.BasePageComponent>
  );
}
